const AboutPage = () => {
  return "Hell world";
};

export default AboutPage;
